import { useState, type FormEvent } from "react";
import type { ContactDetails } from "../types";

interface ContactFormProps {
  demoMode: boolean;
  disabled: boolean;
  onSubmit: (contact: ContactDetails) => Promise<void>;
}

const emptyContact: ContactDetails = {
  company: "",
  name: "",
  email: "",
  phone: "",
};

const demoContact: ContactDetails = {
  company: "株式会社サンプル",
  name: "山田 太郎",
  email: "taro.yamada@example.com",
  phone: "03-1234-5678",
};

export function ContactForm({ demoMode, disabled, onSubmit }: ContactFormProps) {
  const [contact, setContact] = useState(() => demoMode ? demoContact : emptyContact);

  function update(field: keyof ContactDetails, value: string) {
    setContact((current) => ({ ...current, [field]: value }));
  }

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    await onSubmit(contact);
  }

  return (
    <form className="contact-form" onSubmit={handleSubmit}>
      <div className="contact-heading">
        <h2>最後に、ご連絡先を教えてください</h2>
        <p>
          {demoMode
            ? "デモ用の情報を入力済みです。そのまま結果を表示できます。"
            : "担当者からのご連絡に使用します。"}
        </p>
      </div>
      <div className="field-grid">
        <label>
          <span>会社名 <b>必須</b></span>
          <input
            autoComplete="organization"
            required
            readOnly={demoMode}
            value={contact.company}
            onChange={(event) => update("company", event.target.value)}
          />
        </label>
        <label>
          <span>お名前 <b>必須</b></span>
          <input
            autoComplete="name"
            required
            readOnly={demoMode}
            value={contact.name}
            onChange={(event) => update("name", event.target.value)}
          />
        </label>
        <label>
          <span>メールアドレス <b>必須</b></span>
          <input
            autoComplete="email"
            required
            type="email"
            readOnly={demoMode}
            value={contact.email}
            onChange={(event) => update("email", event.target.value)}
          />
        </label>
        <label>
          <span>電話番号</span>
          <input
            autoComplete="tel"
            inputMode="tel"
            readOnly={demoMode}
            value={contact.phone}
            onChange={(event) => update("phone", event.target.value)}
          />
        </label>
      </div>
      <button className="submit-inquiry" type="submit" disabled={disabled}>
        {disabled
          ? "処理しています…"
          : demoMode
            ? "メール結果のデモを見る"
            : "この内容で送信する"}
      </button>
    </form>
  );
}
